import apiConfig from '@constants/apiConfig';
import { sendRequest } from '@services/api';
import { uploadFile } from '@store/actions/app';
import { handleApiResponse } from '@utils/apiHelper';
import { call, takeLatest } from 'redux-saga/effects';
function* _uploadFile({ payload: { params, onCompleted, onError } }) {
    try {
        const result = yield call(sendRequest, apiConfig.file.upload, params);
        handleApiResponse(result, onCompleted, onError);
    } catch (error) {
        onError(error);
    }
}

const sagas = [ takeLatest(uploadFile.type, _uploadFile) ];

export default sagas;
